import { Grid, Card, CardContent, CardActions, Typography, Box } from '@mui/material';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { noteApiKeyStore } from '../../../../api/note-api-key-store';
import { Note } from '../../../../models/note';

interface RecentNotesProps {
  customerID?: any;
}

interface ComponentCell {
  data: any;
}

const ComponentCell = ({ data }: ComponentCell) => {
  return (
    <Card elevation={0} sx={{ mb: 1 }}>
      <CardContent>
        <Typography variant="body1">{data.note}</Typography>
      </CardContent>
      <CardActions disableSpacing>
        <Typography variant="caption" fontStyle={'italic'}>
          Updated on: <i>{data.lastUpdatedOn ? data.lastUpdatedOn : data.createdOn}</i>
        </Typography>
      </CardActions>
    </Card>
  );
};

export const RecentNotes = ({ customerID }: RecentNotesProps) => {
  const { data, isLoading } = useLoadData<ApiResponse<Note[]>>(noteApiKeyStore.getNotes({ customerID: customerID }));

  return (
    <Box className="recentNotesWrapper">
      <Box className="subHead2">
        <Typography variant="h3" className="primaryColor" style={{ marginBottom: '5px' }}>
          RECENT NOTES
        </Typography>
      </Box>
      <Box className="recentNotesContainer" sx={{ pr: 2 }}>
        {data && data?.data.map((item: any) => <ComponentCell key={`${item.noteID}-${item.note}`} data={item} />)}
      </Box>
    </Box>
  );
};
